import React from 'react';

interface SaveFeatureProps {
  onClick?: () => void;
  isSaved?: boolean;
}

const SaveFeature: React.FC<SaveFeatureProps> = ({ onClick, isSaved = false }) => {
  return (
    <button
      onClick={onClick}
      className="hover:opacity-80 transition-opacity flex items-center justify-center"
      style={{
        width: 'clamp(18px, 2.5vh, 31px)',
        height: 'clamp(22px, 3vh, 36px)',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
      }}
      aria-label={isSaved ? 'Saved question' : 'Save question'}
      title={isSaved ? 'Saved' : 'Save question'}
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="100%" 
        height="100%" 
        viewBox="0 0 31 45" 
        fill="none" 
        style={{ display: 'block' }}
      >
        <path
          d="M5.16675 16.7932C5.16675 11.5156 5.16675 8.87676 6.30171 7.23721C7.43667 5.59766 9.26336 5.59766 12.9167 5.59766H18.0834C21.7368 5.59766 23.5635 5.59766 24.6985 7.23721C25.8334 8.87676 25.8334 11.5156 25.8334 16.7932V29.5331C25.8334 34.5399 25.8334 37.0433 24.7429 37.809C23.6523 38.5747 22.2897 37.028 19.5644 33.9347L18.6922 32.9447C17.1598 31.2054 16.3936 30.3357 15.5001 30.3357C14.6066 30.3357 13.8404 31.2054 12.308 32.9447L11.4358 33.9347C8.7105 37.028 7.34784 38.5747 6.25729 37.809C5.16675 37.0433 5.16675 34.5399 5.16675 29.5331V16.7932Z"
          stroke={isSaved ? '#FFE896' : 'white'}
          fill={isSaved ? 'rgba(255, 232, 150, 0.25)' : 'none'}
          strokeWidth="1.5"
        />
      </svg>
    </button>
  );
};

export default SaveFeature;
